import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { each, map } from 'lodash'

import { callApi } from '../services/fetchService'
import { loadGlobals } from '../actions'

import DataTable from '../components/DataTable'
import FaIcon from '../components/FaIcon'
import TableButton from '../components/TableButton'

import { Button, message } from 'antd'



class Plants extends Component {

    state = {
        data: [],
        loading: false
    }

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'plants'
        }).then((data) => {
            this.setState({
                data: each(data, (item) => {
                    item.pharmaceuticalForms = map(item.pharmaceuticalForms, (item) => comboboxes.byKey["pharmaceutical-forms"][item].value)
                    item.pharmaceuticalForms = item.pharmaceuticalForms.join(', ')
                    item.actionsCount = item.actions.length
                }),
                loading: false
            })
        }).catch((err) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    delete = (plant) => {
        const { intl, loadGlobals } = this.props
        callApi({
            endpoint: 'plants/' + plant.id,
            method: 'DELETE'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.deleteSuccess'}))
            this.fetch()
            loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    rowsConfig = (record) => ({
        style: { cursor: 'pointer' },
        onClick: (e) => this.props.history.push('/plant/' + record.id)
    })

    render() {
        const { data, loading } = this.state

        const columns = [
            { title: "plants.nameColumn", dataIndex: "name", type: "string", sorter: true },
            { title: "plants.pharmaceuticalFormsColumn", dataIndex: "pharmaceuticalForms", type: "string", sorter: true },
            { title: "plants.authorizedPregnancyColumn", dataIndex: "authorizedPregnancy", type: "boolean" },
            { title: "plants.authorizedBabyColumn", dataIndex: "authorizedBaby", type: "boolean" },
            { title: "plants.authorizedChildColumn", dataIndex: "authorizedChild", type: "boolean" },
            { title: "plants.actionsCountColumn", dataIndex: "actionsCount", type: "number", sorter: true },
            { title: "misc.actions", width: "100px", key: "action", render: (record) => (
                <TableButton color="red" icon="trash-alt" onClick={this.delete} value={record} confirm />
            ) }
        ]

        return (
            <div>
                <h1><FaIcon icon="leaf" fixedWidth /> <FormattedMessage id="plants.title" /></h1>
                <div className="action-bar"><Link to="/plant"><Button><FaIcon icon="plus"/> <FormattedMessage id="plants.addPlant" /></Button></Link></div>
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" onRow={this.rowsConfig} />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default withRouter(injectIntl(connect(mapStateToProps, {
    loadGlobals
})(Plants)))


// WEBPACK FOOTER //
// ./src/views/Plants.js